<script setup lang="ts">
import { toRefs } from "vue";
import { utc2local } from "@/utils";
import type { PromotionCode } from "@/rvapi";

const props = defineProps<{
  codes: PromotionCode[];
  searching: boolean;
}>();

const { codes, searching } = toRefs(props);
</script>

<template>
  <section v-show="!searching && codes.length > 0">
    <h3>Active promotion codes</h3>
    <pn-table bordered="true" striped="true">
      <table>
        <thead>
          <tr>
            <th>Code</th>
            <th>Value</th>
            <th>Limit</th>
            <th>Expires</th>
            <th>Login required</th>
            <th>Batch label</th>
            <th>Created by</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in codes" :key="p.code">
            <td>{{ p.code }}</td>
            <td>{{ p.value }}</td>
            <td>{{ p.usageLimit }}</td>
            <td>{{ utc2local(p.expireAt) }}</td>
            <td>{{ p.requireLogin ? "Yes" : "" }}</td>
            <td>{{ p.campaign || "" }}</td>
            <td>{{ p.createdBy }}</td>
            <td>{{ utc2local(p.createdAt) }}</td>
          </tr>
        </tbody>
      </table>
    </pn-table>
  </section>
</template>
<style lang="scss" scoped></style>
